module.exports = {
      id: "media-placeholder-usage",
      viewBox: "0 0 632 421",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#media-placeholder",
      toString: function () {
        return this.url;
      }
    }